// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"207":"363822f0","534":"2204f9b1"}[chunkId] + ".css";
};